import { createStore } from 'redux';
import rootReducer from '../modules/reducers';

export default function configureStore(initialState) {
  return createStore(rootReducer, initialState);
}



/** WEBPACK FOOTER **
 ** ./src/store/configureStore.prod.js
 **/